import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/inventories`;
export const API_TAG_PRINT_URL = `${process.env.REACT_APP_API_URL}/tags`;
export const API_INVENTORY_STATUS_URL = `${process.env.REACT_APP_API_URL}/inventoryStatus`


// CREATE =>  POST: add a new product to the server
export function createInventory(inventory) {
    return axios.post(API_URL, { ...inventory });
}

// READ
export function getAllInventories() {
    return axios.get(API_URL);
}

export function getInventoryStatus() {
    return axios.get(API_INVENTORY_STATUS_URL);
}

export function getPaginatedInventories(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getInventoryById(inventoryId) {
    return axios.get(`${API_URL}/${inventoryId}`);
}

export function sendPrintTag(request)  {
    return axios.post(`${process.env.REACT_APP_PRINTER_URL}`, {...request})
}

export function tagPrinted(request) {
    return axios.post(`${API_TAG_PRINT_URL}/print`, {...request});
}

// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the inventory on the server
export function updateInventory(inventoryId, inventory) {
    return axios.put(`${API_URL}/${inventoryId}`, { ...inventory });
}


// DELETE => delete the product from the server
export function deleteInventory(inventoryId) {
    return axios.delete(`${API_URL}/${inventoryId}`);
}
